import { render, staticRenderFns } from "./MetamaskAccountPickerWindow.vue?vue&type=template&id=7fa4a7dd&"
import script from "./MetamaskAccountPickerWindow.vue?vue&type=script&lang=js&"
export * from "./MetamaskAccountPickerWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports